import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { ListRowHeadingValue } from '~/components/list-row';
import { MetaItem, SettingsBody, SettingsData, SettingsHead } from '~/components/settings';
import { formatDate } from '~/lib/datetime';
import type { ChannelGuideSettings__ChannelGuide as ChannelGuide } from '../../queries/settings.generated';

export interface DetailsProps {
  channelGuide: ChannelGuide;
}

export const Details = ({ channelGuide }: DetailsProps) => {
  const { t } = useTranslation();

  return (
    <Box>
      <SettingsHead>{t('common.labels.details')}</SettingsHead>
      <SettingsBody>
        <SettingsData className="last scroll no-space-between">
          <MetaItem className="first">
            <ListRowHeadingValue
              heading={t('pages.channel_guides.detail.details.channels')}
              value={channelGuide.channels.length}
            />
          </MetaItem>
          <MetaItem>
            <ListRowHeadingValue heading={t('common.tabs.shows')} value={channelGuide.showCount} />
          </MetaItem>
          <MetaItem>
            <ListRowHeadingValue
              heading={t('pages.channel_guides.detail.details.default_channel')}
              value={
                channelGuide.defaultChannel?.name ?? t('pages.channel_guides.detail.details.na')
              }
            />
          </MetaItem>
          <MetaItem>
            <ListRowHeadingValue
              heading={t('common.labels.created_at')}
              value={formatDate(channelGuide.createdAt)}
            />
          </MetaItem>
          <MetaItem className="last">
            <ListRowHeadingValue
              heading={t('pages.channel_guides.detail.details.last_updated')}
              value={formatDate(channelGuide.updatedAt)}
            />
          </MetaItem>
        </SettingsData>
      </SettingsBody>
    </Box>
  );
};
